import { Button } from "../../components/ui/button";
import { useState } from "react";
import FormRenderer from "../input-field/form-renderer";
import { profileFields } from "../../config/profile/profile-fields";
import { isFormValid } from "../../utils/validators";

const ProfileDetails = () => {
  const [form, setForm] = useState({});

  return (
    <div className="md:w-2/3 p-4">
      <FormRenderer
        fields={profileFields}
        values={form}
        setValues={setForm}
      />

      <Button
        disabled={!isFormValid(profileFields, form)}
        variant="patient.primary"
        className="w-full rounded-md mt-2"
      >
        Submit
      </Button>
    </div>
  );
};

export default ProfileDetails;

